import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';

import AtacamaExperiencesSection from '../../components/AtacamaExperiencesSection/AtacamaExperiencesSection';
import ImageTextPaginated from '../../components/shared/ImageTextPaginated/ImageTextPaginated';
import PropertyHeroSection from '../../components/PropertyHeroSection/PropertyHeroSection';
import {BlogSection} from '../../components/BrandHomePage/BlogSection/BlogSection';
import HorizontalCarousel from '../../components/HorizontalCarousel/HorizontalCarousel';
import PropertyPanels from '../../components/HorizontalCarousel/panels/PropertyPanels';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import ResortMap from '../../components/ResortMap/ResortMap';
import Hero from '../../components/Hero/Hero';
import Footer from '../../components/Footer/Footer';
import { images } from '../../components/shared/assets';

import { OffersGrid } from '../../components/shared/OffersGrid/OffersGrid';
import { useOverlayManager } from '../../contexts/OverlayContext';

import '../../styles/property-pages.css';
import './IguazuPage.css';


const IguazuPageHardcoded: React.FC = () => {
  const { setHoveredDestination } = useOverlayManager();
  const { t } = useTranslation();

  // Initialize all interactive features
  useEffect(() => {
    // Clear any lingering hover state to ensure correct footer variant
    setHoveredDestination(null);
  }, []);

  return (
    <div className="property-page property-page--iguazu">


      <title>{t('meta:iguazu.home.title')}</title>
      <meta name="description" content={t('meta:iguazu.home.description')} />
      <meta property="og:title" content={t('meta:iguazu.home.title')} />
      <meta property="og:description" content={t('meta:iguazu.home.description')} />


      {/* Navigation - Transparent variant for hero section */}
      <UnifiedNavigation variant="transparent" destination="iguazu" />

      {/* Hero Section */}
      <Hero
        backgroundVideo='https://videos.ctfassets.net/hz1mviiqoqof/5fzkNV7OOqHg3y2lg7FIsR/f43708bb90bb24ee32245f5bb93f9a5a/hero-iguazu.mp4'
        heading={t('properties/iguazu:hero.title')}
      />

      {/* Content Sections with Scroll Reveals */}
      <div className="content-wrapper">

        {/* Premium Carousel - The horizontal carousel we fixed */}
        <HorizontalCarousel>
          <PropertyPanels property="iguazu" />
        </HorizontalCarousel>

        {/* Full Viewport Video Section */}
        <img src="/assets/images/iguazu/iguazu-full.jpg" className="full-viewport-image" />

        {/* Experience Your Own Path Private Excursions Section */}
        <div data-scroll-section="experiences" className="scroll-reveal-section">
          <AtacamaExperiencesSection
            property="iguazu"
            title={t('properties/iguazu:experience.title')}
            description={t('properties/iguazu:experience.description')}
            experiences={[
              {
                image: "/assets/images/iguazu/experience-1.jpg",
                title: t('properties/iguazu:excursions.0.title'),
                category: t('properties/iguazu:excursions.0.location'),
                description: t('properties/iguazu:excursions.0.description')
              },
              {
                image: "/assets/images/iguazu/experience-2.png",
                title: t('properties/iguazu:excursions.1.title'),
                category: t('properties/iguazu:excursions.1.location'),
                description: t('properties/iguazu:excursions.1.description')
              },
              {
                image: "/assets/images/iguazu/experience-3.jpg",
                title: t('properties/iguazu:excursions.2.title'),
                category: t('properties/iguazu:excursions.2.location'),
                description: t('properties/iguazu:excursions.2.description')
              },
              {
                image: "/assets/images/iguazu/experience-4.jpg",
                title: t('properties/iguazu:excursions.3.title'),
                category: t('properties/iguazu:excursions.3.location'),
                description: t('properties/iguazu:excursions.3.description')
              }
            ]}
          />
        </div>

        {/* Dining Section */}
        <div data-scroll-section="dining" className="scroll-reveal-section">
          <ImageTextPaginated
            backgroundColor="#3E5B58"
            foregroundColor="#F3F3F3"
            heading={t('properties/iguazu:restaurant.heading')}
            slides={[
              {
                heading: t('properties/iguazu:restaurant.card1.title'),
                description: t('properties/iguazu:restaurant.card1.description'),
                linkUrl: "/iguazu/dining",
                linkLabel: t('properties/iguazu:restaurant.card1.linkLabel'),
                imageUrl: "/assets/images/iguazu/dining-01.jpg"
              },
              {
                heading: t('properties/iguazu:restaurant.card2.title'),
                description: t('properties/iguazu:restaurant.card2.description'),
                linkUrl: "/iguazu/dining",
                linkLabel: t('properties/iguazu:restaurant.card2.linkLabel'),
                imageUrl: "/assets/images/iguazu/dining-01.jpg"
              },
              {
                heading: t('properties/iguazu:restaurant.card3.title'),
                description: t('properties/iguazu:restaurant.card3.description'),
                linkUrl: "/iguazu/dining",
                linkLabel: t('properties/iguazu:restaurant.card3.linkLabel'),
                imageUrl: "/assets/images/iguazu/dining-01.jpg"
              },
            ]}
          />

        </div>

        {/* Offers Section */}
        <div data-scroll-section="offers" className="scroll-reveal-section">
          <OffersGrid
            heading={t('properties/iguazu:offers.heading')}
            description={t('properties/iguazu:offers.copy')}
            ctaLabel={t('properties/iguazu:offers.cta')}
            ctaLink="/packages"
            offers={
              [
                {
                  id: 1,
                  image: '/assets/images/offers/offer-01.jpg',
                  tag: t('pages/home:offers.tag'),
                  title: t('pages/home:offers.items.combine.title'),
                  moreLink: "/packages/combine-three",
                  moreLabel: t('properties/santa-catarina:journey.cards.combine.viewMore')
                },
                {
                  id: 2,
                  image: 'https://images.ctfassets.net/hz1mviiqoqof/15Cp3o6XVDv7icoa9wFixB/bc2c3f2c8e8fade33be67101c8b93cd0/rainbow-falls.jpg',
                  tag: t('pages/home:offers.tag'),
                  title: t('pages/home:offers.items.stayLonger.title'),
                  moreLink: "/packages/stay-longer",
                  moreLabel: t('properties/santa-catarina:journey.cards.combine.viewMore')
                },
                // {
                //   id: 3,
                //   image: '/assets/Awasi Atacama-17.jpg',
                //   tag: t('pages/home:offers.tag'),
                //   title: t('pages/home:offers.items.wellness.title'),
                //   moreLink: "/packages/re-energize",
                //   moreLabel: t('properties/santa-catarina:journey.cards.combine.viewMore')
                // }
              ]
            }
          />
        </div>

        {/* Map Section */}
        <div data-scroll-section="map" className="scroll-reveal-section">
          <ResortMap
            foregroundColor="#F3F3F3"
            backgroundColor="#3e5b58"
            backgroundImage="/assets/images/iguazu/iguazu-full.jpg"
            mapImageUrl="/assets/images/iguazu/map.png"
            heading={t('properties/iguazu:map.title')}
            fromList={
              [
                {
                  "heading": t('properties/iguazu:map.fromBuenosAires.title'),
                  "description": t('properties/iguazu:map.fromBuenosAires.description')
                },
                {
                  "heading": t('properties/iguazu:map.fromSaoPaulo.title'),
                  "description": t('properties/iguazu:map.fromSaoPaulo.description')
                },
                {
                  "heading": t('properties/iguazu:map.otherAirports.title'),
                  "description": t('properties/iguazu:map.otherAirports.description')
                }
              ]
            }
          />
        </div>

        {/* Blog Section */}
        <div data-scroll-section="blog" className="scroll-reveal-section">
          <BlogSection />
        </div>

        {/* Instagram Section */}
        <InstagramSection
          posts={
            [
              { src: '/assets/instagram/instagram-iguazu-01.jpg', alt: "Instagram post 1" },
              { src: '/assets/instagram/instagram-iguazu-02.jpg', alt: "Instagram post 2" },
              { src: '/assets/instagram/instagram-iguazu-03.mp4', alt: "Instagram post 3", isVideo: true },
              { src: '/assets/instagram/instagram-iguazu-04.jpg', alt: "Instagram post 4" },
            ]
          }
        />

        {/* Footer */}
        <Footer variant="iguazu" />
      </div>
    </div>
  );
};

export default IguazuPageHardcoded;